import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const CategoryHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Category Management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default CategoryHeader;
